import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'intrasense-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent implements OnInit, OnChanges {
  @Input() visible: boolean = false;
  public isLoading: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges() {
    this.isLoading = this.visible;
  }

}
